import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Link } from "react-router-dom";
import logoNeuroResearch from "@/assets/logo-neuroresearch.webp";

const Footer = () => {
  return (
    <footer className="bg-card border-t border-border py-16">
      <div className="container mx-auto px-4">
        <div className="grid lg:grid-cols-4 md:grid-cols-2 gap-8 mb-12">
          <div>
            <Link to="/pt" className="inline-block mb-4">
              <img 
                src={logoNeuroResearch} 
                alt="NeuroResearch Foundation" 
                width={179}
                height={48}
                loading="lazy"
                decoding="async"
                className="h-12 w-auto"
              />
            </Link>
            <p className="text-muted-foreground leading-relaxed">
              Pesquisando hoje para curar amanhã. Dedicados a encontrar soluções 
              para as doenças neurológicas mais desafiadoras.
            </p>
          </div>

          <div>
            <h4 className="text-lg font-semibold mb-4 text-card-foreground">Pesquisa</h4>
            <ul className="space-y-2 text-muted-foreground">
              <li><Link to="/pt/projetos-pesquisa" onClick={() => window.scrollTo(0, 0)} className="hover:text-primary transition-colors">Pesquisa e Projetos</Link></li>
              <li><Link to="/pt/colaboracoes" onClick={() => window.scrollTo(0, 0)} className="hover:text-primary transition-colors">Colaborações</Link></li>
              <li><Link to="/pt/ensaios-clinicos" onClick={() => window.scrollTo(0, 0)} className="hover:text-primary transition-colors">Ensaios Clínicos</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-semibold mb-4 text-card-foreground">Participar</h4>
            <ul className="space-y-2 text-muted-foreground">
              <li>
                <Link 
                  to="/pt" 
                  onClick={() => {
                    setTimeout(() => {
                      const donationSection = document.getElementById('donation-section');
                      if (donationSection) {
                        donationSection.scrollIntoView({ behavior: 'smooth' });
                      }
                    }, 100);
                  }}
                  className="hover:text-primary transition-colors"
                >
                  Doar
                </Link>
              </li>
              <li><Link to="/pt/voluntariado" onClick={() => window.scrollTo(0, 0)} className="hover:text-primary transition-colors">Voluntariado</Link></li>
              <li><Link to="/pt/eventos" onClick={() => window.scrollTo(0, 0)} className="hover:text-primary transition-colors">Eventos</Link></li>
              <li><Link to="/pt/newsletter" onClick={() => window.scrollTo(0, 0)} className="hover:text-primary transition-colors">Newsletter</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-semibold mb-4 text-card-foreground">Mantenha-se Informado</h4>
            <p className="text-muted-foreground mb-4">
              Inscreva-se para receber atualizações sobre nossa pesquisa
            </p>
            <div className="flex gap-2">
              <Button 
                variant="secondary"
                asChild
              >
                <Link to="/pt/newsletter">Inscrever-se</Link>
              </Button>
            </div>
          </div>
        </div>

        <div className="border-t border-border pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <div className="text-muted-foreground">
              © 2024 Green Life Bcn Foundation. Todos os direitos reservados.
            </div>
            <div className="flex gap-6 text-muted-foreground">
              <Link to="/pt/privacidade" onClick={() => window.scrollTo(0, 0)} className="hover:text-primary transition-colors">Privacidade</Link>
              <Link to="/pt/termos-de-uso" onClick={() => window.scrollTo(0, 0)} className="hover:text-primary transition-colors">Termos</Link>
              <Link to="/pt/contato" onClick={() => window.scrollTo(0, 0)} className="hover:text-primary transition-colors">Contato</Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
